/* tslint:disable */
import {
  PropertyUnits,
  UserProfile,
  Lease,
  InspectionFile
} from '../index';

declare var Object: any;
export interface HouseInspectionInterface {
  "id"?: number;
  "property_unit_id": number;
  "caretaker_id": number;
  "inspection_type": string;
  "inspection_date": Date;
  "status"?: string;
  "tenant_id"?: number;
  "lease_id"?: number;
  "notes"?: string;
  "inspection_set_number"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  propertyUnit?: PropertyUnits;
  caretaker?: UserProfile;
  tenant?: UserProfile;
  lease?: Lease;
  inspectionFiles?: InspectionFile[];
}

export class HouseInspection implements HouseInspectionInterface {
  "id": number;
  "property_unit_id": number;
  "caretaker_id": number;
  "inspection_type": string;
  "inspection_date": Date;
  "status": string;
  "tenant_id": number;
  "lease_id": number;
  "notes": string;
  "inspection_set_number": number;
  "createdAt": Date;
  "updatedAt": Date;
  propertyUnit: PropertyUnits;
  caretaker: UserProfile;
  tenant: UserProfile;
  lease: Lease;
  inspectionFiles: InspectionFile[];
  constructor(data?: HouseInspectionInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `HouseInspection`.
   */
  public static getModelName() {
    return "HouseInspection";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of HouseInspection for dynamic purposes.
  **/
  public static factory(data: HouseInspectionInterface): HouseInspection{
    return new HouseInspection(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'HouseInspection',
      plural: 'HouseInspections',
      path: 'HouseInspections',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "property_unit_id": {
          name: 'property_unit_id',
          type: 'number'
        },
        "caretaker_id": {
          name: 'caretaker_id',
          type: 'number'
        },
        "inspection_type": {
          name: 'inspection_type',
          type: 'string'
        },
        "inspection_date": {
          name: 'inspection_date',
          type: 'Date'
        },
        "status": {
          name: 'status',
          type: 'string',
          default: 'DRAFT'
        },
        "tenant_id": {
          name: 'tenant_id',
          type: 'number'
        },
        "lease_id": {
          name: 'lease_id',
          type: 'number'
        },
        "notes": {
          name: 'notes',
          type: 'string'
        },
        "inspection_set_number": {
          name: 'inspection_set_number',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        propertyUnit: {
          name: 'propertyUnit',
          type: 'PropertyUnits',
          model: 'PropertyUnits',
          relationType: 'belongsTo',
                  keyFrom: 'property_unit_id',
          keyTo: 'id'
        },
        caretaker: {
          name: 'caretaker',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'caretaker_id',
          keyTo: 'id'
        },
        tenant: {
          name: 'tenant',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'tenant_id',
          keyTo: 'id'
        },
        lease: {
          name: 'lease',
          type: 'Lease',
          model: 'Lease',
          relationType: 'belongsTo',
                  keyFrom: 'lease_id',
          keyTo: 'id'
        },
        inspectionFiles: {
          name: 'inspectionFiles',
          type: 'InspectionFile[]',
          model: 'InspectionFile',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'house_inspection_id'
        },
      }
    }
  }
}
